import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Trophy, Radio, ListOrdered, Building2, PenLine, Lock, Gavel, ClipboardCheck, MonitorPlay } from "lucide-react";
import { API, isAdmin } from "@/lib/api";
import { useT } from "@/lib/i18n";
import { Logo } from "@/components/fly/Logo";
import { HomeTile } from "@/components/fly/HomeTile";
import { LangSwitch } from "@/components/fly/LangSwitch";
import { MiniCountdown } from "@/components/fly/SignupDeadline";

const publicTiles = [
  { key: "ppv", icon: MonitorPlay, tk: "ppv", id: "home-ppv-link", color: "text-fuchsia-400", iconColor: "text-fuchsia-400" },
  { key: "signup", to: "/zapisy", icon: PenLine, tk: "signup", id: "home-signup-link", color: "text-amber-300" },
  { key: "now", to: "/teraz-na-scenie", icon: Radio, tk: "now", id: "home-now-link", color: "text-emerald-400" },
  { key: "results", to: "/wyniki", icon: Trophy, tk: "results", id: "home-results-link", color: "text-red-500" },
  { key: "startlist", to: "/lista-startowa", icon: ListOrdered, tk: "startlist", id: "home-startlist-link" },
  { key: "always", to: "/sedzia/login", icon: Gavel, tk: "judge", id: "home-judge-link", noDesc: true },
  { key: "always", to: "/rejestracja/login", icon: ClipboardCheck, tk: "registration", id: "home-registration-link", noDesc: true },
];
const orgTile = { to: "/organizacja", icon: Building2, title: "Organizacja", id: "home-org-link" };

const PUBLIC_ONLY = ["ppv", "signup", "now", "results", "startlist"];

export default function Home() {
  const { t, lang } = useT();
  const [vis, setVis] = useState(null);
  useEffect(() => {
    axios.get(`${API}/public/home`).then((r) => setVis(r.data)).catch(() => setVis({ now: true, results: true, startlist: true, signup: false }));
  }, []);
  const shown = vis ? publicTiles.filter((x) => (x.key === "always" || vis[x.key]) && (lang === "pl" || PUBLIC_ONLY.includes(x.key))).map((x) => ({
    ...x, title: t(`home.${x.tk}.title`), desc: x.noDesc ? null : t(`home.${x.tk}.desc`),
    href: x.key === "ppv" ? vis.ppv_url : undefined,
    extra: x.key === "signup" ? <MiniCountdown start={vis.signup_start} end={vis.signup_deadline} /> : undefined,
  })) : [];
  return (
    <main className="max-w-7xl mx-auto px-5 sm:px-8 py-14 sm:py-20 relative">
      <LangSwitch className="absolute top-4 right-5 sm:right-8" />
      <div className="rise flex justify-center">
        <Logo size="lg" />
      </div>
      <div className="mt-6 text-center rise" style={{ animationDelay: "80ms" }}>
        <p data-testid="home-date" className="font-mono text-xs uppercase tracking-[0.25em] text-blue-400">{vis ? `${vis.event_place || ""} · ${vis.event_dates || ""}` : " "}</p>
      </div>
      <div className="mt-12 max-w-2xl">
        <div className="grid gap-4" data-testid="home-public-tiles">
          {shown.map((x, i) => <HomeTile key={x.id} t={x} i={i} />)}
        </div>
        {vis && isAdmin() && lang === "pl" && <HomeTile t={orgTile} i={shown.length} className="mt-10 border-dashed" />}
        {vis && !isAdmin() && lang === "pl" && (
          <div className="mt-16 text-center sm:text-left">
            <Link to="/admin/login" data-testid="home-admin-panel-link" className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-[0.2em] text-slate-500 hover:text-blue-300 transition-colors">
              <Lock className="w-3.5 h-3.5" />{t("home.admin")}
            </Link>
          </div>
        )}
      </div>
    </main>
  );
}
